/* Stillsoft exit offer. Markup, settings and the product data live in
   sections/stillsoft-exit-offer.liquid; see the comment at its top. */
(function(){
  var d=document.querySelector('[data-ss-xo]');if(!d||!d.showModal)return;
  var KEY='ss_xo_v1',CK='ss_xo_checkout';
  function seen(){try{return !!sessionStorage.getItem(KEY);}catch(e){return false;}}
  if(seen())return;
  var H=d.dataset.handle,GIFT=String(d.dataset.gift||''),WAIT=(+d.dataset.wait||15)*1000,MIN=+d.dataset.minutes||3;
  var PDP=d.dataset.pdp==='true',EMPTY=d.dataset.empty!=='false';
  var data={options:[],values:[],v:[]};try{data=JSON.parse(d.querySelector('[data-ss-xo-data]').textContent);}catch(e){}
  var CI=data.options.indexOf('Color'),SI=data.options.indexOf('Size');
  var COLORS=CI>=0?data.values[CI]:[],SIZES=SI>=0?data.values[SI]:[];
  var body=document.body;
  var armed=false,shown=false,trapped=false,gesture=false,leaving=false,hiddenAt=0,tick=null,left=MIN*60;
  var tops=[],qty=0,capIn=false,cartSize=null,cartColors=[];
  var step1=d.querySelector('[data-ss-xo-step1]'),step2=d.querySelector('[data-ss-xo-step2]');
  var sizesEl=d.querySelector('[data-ss-xo-sizes]'),colorsEl=d.querySelector('[data-ss-xo-colors]');
  var goBtn=d.querySelector('[data-ss-xo-go]'),msg=d.querySelector('[data-ss-xo-msg]');
  var sizeLabel=d.querySelector('[data-ss-xo-size-label]'),colorsLabel=d.querySelector('[data-ss-xo-colors-label]');
  var picked=0,need=0,size=null;

  function drawerOpen(){return body.classList.contains('upcartPopupShow');}
  function overlayOpen(){return drawerOpen()||body.classList.contains('klaviyo-prevent-body-scrolling');}
  function canOffer(){return qty>0||(PDP&&EMPTY);}
  function isGift(i){return String(i.variant_id)===GIFT||!!(i.properties&&i.properties._ss_gift);}
  function isBundle(i){var p=i.properties||{};for(var k in p){if(k.indexOf('kaching')>=0)return true;}return false;}
  function optOf(i,name){var o=(i.options_with_values||[]).filter(function(x){return x.name===name;})[0];return o?o.value:null;}

  function cart(cb){
    fetch('/cart.js',{credentials:'same-origin'}).then(function(r){return r.json();}).then(function(c){
      var items=c.items||[];
      tops=items.filter(function(i){return i.handle===H&&!isGift(i);});
      qty=tops.reduce(function(a,i){return a+i.quantity;},0);
      capIn=items.some(function(i){return String(i.variant_id)===GIFT;});
      cartSize=tops.length?optOf(tops[tops.length-1],'Size'):null;
      cartColors=tops.map(function(i){return optOf(i,'Color');});
      if(canOffer())trap();
      cb&&cb();
    }).catch(function(){});
  }

  /* Phone Back: one entry, pushed once after her first tap and after WAIT. */
  function trap(){
    if(trapped||shown||!armed||!gesture||!canOffer())return;
    trapped=true;try{history.pushState({ssxo:1},'');}catch(e){trapped=false;}
  }
  window.addEventListener('popstate',function(){
    if(!trapped)return;
    trapped=false;
    if(drawerOpen()){if(window.upcartCloseCart)window.upcartCloseCart();return;}
    if(!show('back')){try{history.back();}catch(e){}}
  });

  function show(why){
    if(shown||leaving||seen()||!canOffer()||overlayOpen())return false;
    if(!armed&&why!=='cart'&&why!=='checkout')return false;
    shown=true;
    try{sessionStorage.setItem(KEY,'1');}catch(e){}
    step1.hidden=false;step2.hidden=true;
    d.showModal();
    var el=d.querySelector('[data-ss-xo-timer]');
    tick=setInterval(function(){left--;if(left<=0){close();return;}el.textContent=Math.floor(left/60)+':'+('0'+left%60).slice(-2);},1000);
    return true;
  }
  function close(){clearInterval(tick);try{d.close();}catch(e){d.removeAttribute('open');}}
  d.addEventListener('close',function(){clearInterval(tick);});

  /* Triggers */
  setTimeout(function(){armed=true;trap();},WAIT);
  function onGesture(){gesture=true;trap();}
  document.addEventListener('pointerdown',onGesture,{once:true,capture:true});
  document.addEventListener('keydown',onGesture,{once:true,capture:true});
  document.addEventListener('click',function(){setTimeout(cart,1500);},true);
  document.addEventListener('mouseout',function(e){if(!e.relatedTarget&&e.clientY<=0)show('mouse');});
  document.addEventListener('visibilitychange',function(){
    if(document.hidden){hiddenAt=Date.now();}
    else if(hiddenAt&&Date.now()-hiddenAt>1500){hiddenAt=0;show('return');}
  });
  window.addEventListener('pagehide',function(){leaving=true;});
  window.addEventListener('beforeunload',function(){leaving=true;});

  /* Right after the Upcart drawer closes with the top in it. */
  var wasOpen=drawerOpen();
  new MutationObserver(function(){
    var open=drawerOpen();
    if(wasOpen&&!open){setTimeout(function(){if(leaving)return;cart(function(){if(qty>0)show('cart');});},600);}
    wasOpen=open;
  }).observe(body,{attributes:true,attributeFilter:['class']});

  /* Back from checkout. */
  function markCheckout(){try{sessionStorage.setItem(CK,'1');}catch(e){}}
  (function hook(n){
    if(typeof window.upcartSubscribeCheckoutClicked==='function'){try{window.upcartSubscribeCheckoutClicked(markCheckout);}catch(e){}return;}
    if(n<40)setTimeout(function(){hook(n+1);},500);
  })(0);
  document.addEventListener('submit',function(e){var f=e.target;if(f&&f.action&&f.action.indexOf('/cart')>=0&&f.querySelector('[name="checkout"]'))markCheckout();},true);
  function fromCheckout(){
    var flag=false;try{flag=sessionStorage.getItem(CK)==='1';}catch(e){}
    if(!flag)return;
    try{sessionStorage.removeItem(CK);}catch(e){}
    leaving=false;
    cart(function(){if(qty>0)show('checkout');});
  }
  window.addEventListener('pageshow',function(e){
    var nav=(performance.getEntriesByType&&performance.getEntriesByType('navigation')[0])||{};
    if(e.persisted||nav.type==='back_forward')fromCheckout();
    else{try{sessionStorage.removeItem(CK);}catch(x){}}
  });

  cart();

  /* Dialog clicks */
  d.addEventListener('click',function(e){
    if(e.target===d){var b=d.getBoundingClientRect();if(e.clientX<b.left||e.clientX>b.right||e.clientY<b.top||e.clientY>b.bottom)close();return;}
    if(e.target.closest('[data-ss-xo-close]')){close();return;}
    if(e.target.closest('[data-ss-xo-back]')){step2.hidden=true;step1.hidden=false;return;}
    var p=e.target.closest('[data-ss-xo-pick]');if(p){pick(+p.getAttribute('data-ss-xo-pick'));return;}
    var s=e.target.closest('[data-ss-xo-size]');if(s){size=s.getAttribute('data-ss-xo-size');paintSizes();return;}
    if(e.target.closest('[data-ss-xo-go]'))addAndGo();
  });

  function go(n){window.location.href='/discount/'+encodeURIComponent(d.dataset['code'+n])+'?redirect=%2Fcheckout';}
  function post(path,payload){return fetch(path,{method:'POST',credentials:'same-origin',headers:{'Content-Type':'application/json','Accept':'application/json'},body:JSON.stringify(payload)});}
  function lock(on){d.querySelectorAll('button').forEach(function(b){if(!b.hasAttribute('data-ss-xo-close'))b.disabled=on;});}
  function withCap(n){return n>=3&&GIFT&&!capIn?post('/cart/add.js',{items:[{id:+GIFT,quantity:1,properties:{_ss_gift:'cap'}}]}):Promise.resolve();}

  function pick(n){
    picked=n;
    cart(function(){
      need=n-qty;
      if(need<=0){
        lock(true);
        var extra=qty-n,updates={},rows=tops.slice().reverse();
        rows.forEach(function(l){
          if(extra<=0||isBundle(l))return;
          var take=Math.min(extra,l.quantity);updates[l.key]=l.quantity-take;extra-=take;
        });
        var done=false;function fin(){if(done)return;done=true;go(n);}
        setTimeout(fin,4000);
        (Object.keys(updates).length?post('/cart/update.js',{updates:updates}):Promise.resolve())
          .then(function(){return withCap(n);}).then(fin,fin);
        return;
      }
      openStep2();
    });
  }

  function openStep2(){
    size=cartSize&&SIZES.indexOf(cartSize)>=0?cartSize:null;
    sizeLabel.textContent=qty>0?'Your size (same as your cart)':'Your size';
    colorsLabel.textContent=need===1?'Your color':'Your colors';
    sizesEl.innerHTML='';
    SIZES.forEach(function(s){
      var b=document.createElement('button');b.type='button';b.className='ss-xo__size';
      b.setAttribute('data-ss-xo-size',s);b.textContent=s;b.setAttribute('aria-pressed','false');
      sizesEl.appendChild(b);
    });
    colorsEl.innerHTML='';
    var pool=COLORS.filter(function(c){return cartColors.indexOf(c)<0;});
    if(!pool.length)pool=COLORS.slice();
    for(var k=0;k<need;k++){
      var row=document.createElement('label');row.className='ss-xo__row';
      var t=document.createElement('span');t.textContent=need===1?'Color':'Top '+(qty+k+1);
      var sel=document.createElement('select');sel.setAttribute('data-ss-xo-color','');
      COLORS.forEach(function(c){var o=document.createElement('option');o.value=c;o.textContent=c;sel.appendChild(o);});
      sel.value=pool[k%pool.length];
      row.appendChild(t);row.appendChild(sel);colorsEl.appendChild(row);
    }
    msg.textContent='';
    paintSizes();
    step1.hidden=true;step2.hidden=false;
  }

  function paintSizes(){
    sizesEl.querySelectorAll('[data-ss-xo-size]').forEach(function(b){b.setAttribute('aria-pressed',String(b.getAttribute('data-ss-xo-size')===size));});
    goBtn.disabled=!size;
    goBtn.textContent=size?'Get my price':'Pick your size';
  }

  function variantFor(c,s){
    for(var i=0;i<data.v.length;i++){var o=data.v[i].o||[];if(o[CI]===c&&o[SI]===s)return data.v[i].i;}
    return null;
  }

  function addAndGo(){
    if(!size)return;
    var items=[];
    colorsEl.querySelectorAll('[data-ss-xo-color]').forEach(function(sel){
      var id=variantFor(sel.value,size);if(!id)return;
      var hit=items.filter(function(x){return x.id===id;})[0];
      if(hit)hit.quantity++;else items.push({id:id,quantity:1});
    });
    if(!items.length){msg.textContent='Please pick your size and colors.';return;}
    lock(true);msg.textContent='';
    var timer=setTimeout(function(){lock(false);msg.textContent='That took too long. Please tap again.';},8000);
    post('/cart/add.js',{items:items})
      .then(function(r){if(!r.ok)throw new Error('add');return withCap(picked);})
      .then(function(){clearTimeout(timer);go(picked);})
      .catch(function(){clearTimeout(timer);lock(false);msg.textContent='Something went wrong. Please tap again.';});
  }
})();